import { useBetAmountInputButtons } from '@/hooks/useBetAmountInputButtons';
import { BetAmountInputButtonsProps } from '../props';
import styles from './styles.module.scss';
import useTranslation from 'next-translate/useTranslation';
import { useMemo } from 'react';
import BetAmountInputButtonsV2Skeleton from './Skeleton';
import { useWalletsMe } from '@/api/wallets';
import { BetStatus } from '@/models/bet/status';
import { Account } from '@starsoft/common/models';
import { getMoneyOrAmount } from '@starsoft/common/utils';
import { WalletService } from '@starsoft/common/services';
import { BetStatusId } from '@/models/bet/status/id';

export default function BetAmountInputButtonsV2({
  bet,
  isLoading,
}: BetAmountInputButtonsProps) {
  const { t } = useTranslation('common');
  const { handleDoubleAmount, handleHalfAmount, setMaxAmount, isDisabled } =
    useBetAmountInputButtons(bet);
  const { wallet } = useWalletsMe();
  const balance: string = useMemo(() => {
    if (
      !!bet &&
      bet?.status?.id?.toString() === BetStatusId.Open?.toString() &&
      !!bet?.amount
    ) {
      const account: Account = wallet?.accounts?.find(
        account => account?.coin?.id === bet?.coin?.id,
      );

      if (!account) {
        return '';
      }

      return WalletService.maskCurrency({
        amount: getMoneyOrAmount(account?.balance),
        coin: account?.coin,
      });
    }

    return WalletService.maskCurrency({
      amount: getMoneyOrAmount(wallet?.currentAccount?.balance),
      coin: wallet?.currentAccount?.coin,
    });
  }, [bet, wallet]);

  if (isLoading) {
    return <BetAmountInputButtonsV2Skeleton />;
  }

  return (
    <div className={styles.container}>
      <div
        className={`${styles.container__row} ${styles['container__row--full']}`}
      >
        <button
          className={`${styles.container__button}`}
          disabled={isDisabled}
          onClick={handleHalfAmount}
        >
          ½
        </button>
        <button
          className={`${styles.container__button}`}
          disabled={isDisabled}
          onClick={handleDoubleAmount}
        >
          2x
        </button>
        <button
          className={`${styles.container__button}`}
          disabled={isDisabled}
          onClick={setMaxAmount}
        >
          {t('max_label')}
        </button>
      </div>

      <div className={styles.container__row}>
        <span
          className={`${styles.container__text} ${styles['container__text--secondary']}`}
        >
          {t('balance')}:
        </span>
        <span className={styles.container__text}>{balance}</span>
      </div>
    </div>
  );
}
